import React, {useCallback, useEffect, useRef} from 'react';

import {
  HIGHLIGHT_HOVERED_CLASS,
  TEXT_HIGHLIGHT_CLASS_PREFIX,
} from 'app/general/structures/UserContentContainer/utils/highlightUtils';

import {useTextHighlights} from '../TextHighlightsContextProvider';

type Props = {
  children: JSX.Element;
  enabled: boolean;
};

const getHighlights = (classList: DOMTokenList) => {
  const conversationIds: Array<string> = [];
  classList.forEach((className) => {
    if (hasHighlight(className)) {
      conversationIds.push(className.split(TEXT_HIGHLIGHT_CLASS_PREFIX)[1]);
    }
  });

  return conversationIds;
};

const hasHighlight = (className: string) =>
  className.indexOf(TEXT_HIGHLIGHT_CLASS_PREFIX) !== -1;

export const TextHighlightHoverListener = ({children, enabled}: Props) => {
  const ref = useRef<HTMLDivElement>(null);

  const {hoveredConversationId, setHoveredConversationId} = useTextHighlights();
  const handleMouseOver = useCallback(({target}) => {
    if (hasHighlight(target?.className || '')) {
      getHighlights(target.classList).forEach((conversationId) => {
        setHoveredConversationId(conversationId);
      });
    }
  }, []);

  const handleMouseOut = useCallback(() => {
    setHoveredConversationId(null);
  }, []);

  useEffect(() => {
    if (ref.current != null) {
      const prevHighlights = ref.current.querySelectorAll(
        `.${HIGHLIGHT_HOVERED_CLASS}`
      );
      prevHighlights.forEach((el) =>
        el.classList.remove(HIGHLIGHT_HOVERED_CLASS)
      );
      if (hoveredConversationId) {
        const comments = ref.current.querySelectorAll(
          `.${TEXT_HIGHLIGHT_CLASS_PREFIX}${hoveredConversationId}`
        );
        comments.forEach((el) => el.classList.add(HIGHLIGHT_HOVERED_CLASS));
      }
    }
  }, [hoveredConversationId]);

  if (!enabled) {
    return children;
  }

  return (
    <div ref={ref} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
      {children}
    </div>
  );
};
